import { COLORS } from '@/lib/constants/colors'

export default function Divider() {
  return (
    <div
      style={{
        borderBottom: '1px solid',
        borderColor: COLORS.BORDER.DEFAULT,
      }}
    />
  )
}
